import { z } from 'zod';

import { Box, Heading, List, ListItem, Text } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';

export const statsSchema = z.object({
  title: z.string(),
  stats: z.array(
    z.object({
      statValue: z.string(),
      statLabel: z.string(),
    })
  ),
});

export type StatsProps = z.infer<typeof statsSchema>;

export function Stats({ title, stats }: StatsProps) {
  return (
    <Box as='section' backgroundColor='accent.sky.100' padding={{ base: '40px 0px', md: '64px 0px' }}>
      <ContentContainer
        alignItems='center'
        display='flex'
        gap='32px'
        flexDirection={{
          base: 'column',
          md: 'row',
        }}
      >
        <Heading as='h2' maxWidth='332px' size='h2' textAlign={{ base: 'center', md: 'left' }}>
          {title}
        </Heading>
        <List
          display='flex'
          flex='1'
          gap='40px'
          justifyContent='space-between'
          flexDirection={{
            base: 'column',
            md: 'row',
          }}
        >
          {stats.map(({ statValue, statLabel }) => (
            <ListItem key={`${statValue} ${statLabel}`}>
              <Text
                display='flex'
                flexDirection='column'
                textAlign={{
                  base: 'center',
                  md: 'left',
                }}
              >
                <Heading as='span' color='blue.700' fontWeight='500' size='xl'>
                  {statValue}
                </Heading>
                <Box as='span' textStyle='paragraph'>
                  {statLabel}
                </Box>
              </Text>
            </ListItem>
          ))}
        </List>
      </ContentContainer>
    </Box>
  );
}
